import React, { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import './InvoiceProcessingKPI.css';
import CustomTooltip from '../../../../../Components/custom_components/CustomTooltip/CustomTooltip';
import { dashboardContext } from '../../../Dashboard';
import TextSkeleton from '../../../../../Components/Skeletons/TextSkeleton';

const InvoiceProcessingKPI = () => {
    const { data, isLoading } = useContext(dashboardContext);

    const columns = ['Schedule Code', 'Invoice Date', 'Days Taken'];
    return (
        <Box className="invoice-kpi-container">
            <div className="invoice-kpi-header">
                <span className="invoice-kpi-title">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `Invoice Processing KPI`}</span>
            </div>

            <div className="invoice-kpi-columns">
                {columns.map((col, idx) => (
                    <span key={idx} className="invoice-kpi-column-header">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${col}`}</span>
                ))}
            </div>

            <Divider />
            <Box className="invoice-kpi-list">
                {data?.invoicesKPI?.map((data, index) => (
                    <>
                        <div key={index} className="invoice-kpi-row">
                            <CustomTooltip title={data.ScheduleCode}>
                                <span className="invoice-kpi-column invoice-kpi-worksite">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${data?.ScheduleCode || `N/A `}`}</span>
                            </CustomTooltip>
                            <span className="invoice-kpi-column invoice-kpi-date">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${data?.InvoicesDate || `N/A `}`}</span>
                            <span className="invoice-kpi-column ">
                                <span className={`invoice-kpi-days }`}>
                                    {isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : ` ● ${data?.TotalManDays || `N/A `} Days`}
                                </span>
                            </span>
                        </div>
                        <Divider />
                    </>
                ))}

            </Box>
            <Divider />
        </Box>
    );
};

export default InvoiceProcessingKPI;
